import { render, staticRenderFns } from "@/modules/User/templates/users-list.html?vue&type=template&id=4fef3fd0&scoped=true&"
import script from "@/modules/User/scripts/users-list.ts?vue&type=script&lang=js&"
export * from "@/modules/User/scripts/users-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/User/styles/users-list.scss?vue&type=style&index=0&id=4fef3fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef3fd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VForm,VImg,VTooltip})
